export enum PageType {
  CATEGORY = 'category',
  DEFAULT = 'default',
}
